export type FollowUpStatus = 'pending' | 'contacted' | 'snoozed'
export type LoanPurpose = 'Purchase' | 'Refinance'

export type FollowUpLead = {
  id: string
  name: string
  phone: string
  email: string
  loanAmount: number
  loanPurpose: LoanPurpose
  lastContact: string
  nextFollowUp: string
  campaignName: string
  status: FollowUpStatus
}

/** Email campaigns a borrower can be enrolled into from the follow-up queue. */
export const availableCampaigns = [
  'First-Time Buyer Nurture',
  'Rate Drop Alert',
  'Post-Closing Follow-up',
  'Pre-Approval Follow-up',
  'Cash-Out Refi Education',
]

const at = (dayOffset: number, hour: number, minute = 0): string => {
  const date = new Date()
  date.setDate(date.getDate() + dayOffset)
  date.setHours(hour, minute, 0, 0)
  return date.toISOString()
}

export const followUpLeads: FollowUpLead[] = [
  {
    id: 'F-1001',
    name: 'Robert & Ana Silva',
    phone: '(786) 555-0104',
    email: 'silva.family@email.com',
    loanAmount: 329500,
    loanPurpose: 'Refinance',
    lastContact: at(-1, 16, 10),
    nextFollowUp: at(0, 11, 30),
    campaignName: 'Cash-Out Refi Education',
    status: 'pending',
  },
  {
    id: 'F-1002',
    name: 'Priya Natarajan',
    phone: '(908) 555-0129',
    email: 'priya.n@email.com',
    loanAmount: 450000,
    loanPurpose: 'Purchase',
    lastContact: at(-1, 18, 10),
    nextFollowUp: at(0, 14, 0),
    campaignName: 'First-Time Buyer Nurture',
    status: 'pending',
  },
  {
    id: 'F-1003',
    name: 'Jasmine Cole',
    phone: '(678) 555-0198',
    email: 'jcole@email.com',
    loanAmount: 275000,
    loanPurpose: 'Purchase',
    lastContact: at(0, 8, 45),
    nextFollowUp: at(0, 16, 0),
    campaignName: 'Pre-Approval Follow-up',
    status: 'pending',
  },
  {
    id: 'F-1004',
    name: 'Marcus Webb',
    phone: '(917) 555-0113',
    email: 'm.webb@email.com',
    loanAmount: 610000,
    loanPurpose: 'Refinance',
    lastContact: at(-2, 10, 20),
    nextFollowUp: at(0, 9, 15),
    campaignName: '',
    status: 'pending',
  },
  {
    id: 'F-1005',
    name: 'Grace Lindqvist',
    phone: '(212) 555-0177',
    email: 'grace.l@email.com',
    loanAmount: 689000,
    loanPurpose: 'Purchase',
    lastContact: at(-3, 13, 0),
    nextFollowUp: at(-1, 15, 0),
    campaignName: 'Rate Drop Alert',
    status: 'pending',
  },
  {
    id: 'F-1006',
    name: 'Danielle Ferro',
    phone: '(305) 555-0142',
    email: 'danielle.ferro@email.com',
    loanAmount: 385000,
    loanPurpose: 'Purchase',
    lastContact: at(0, 7, 55),
    nextFollowUp: at(0, 17, 30),
    campaignName: '',
    status: 'pending',
  },
  {
    id: 'F-1007',
    name: 'Devon Price',
    phone: '(407) 555-0155',
    email: 'devon.price@email.com',
    loanAmount: 415000,
    loanPurpose: 'Purchase',
    lastContact: at(0, 9, 30),
    nextFollowUp: at(1, 10, 0),
    campaignName: 'Post-Closing Follow-up',
    status: 'contacted',
  },
  {
    id: 'F-1008',
    name: 'Aaron Whitfield',
    phone: '(407) 555-0166',
    email: 'awhitfield@email.com',
    loanAmount: 512000,
    loanPurpose: 'Purchase',
    lastContact: at(0, 10, 5),
    nextFollowUp: at(2, 11, 0),
    campaignName: 'First-Time Buyer Nurture',
    status: 'contacted',
  },
  {
    id: 'F-1009',
    name: 'Sandra Kim',
    phone: '(201) 555-0187',
    email: 'sandra.kim@email.com',
    loanAmount: 505000,
    loanPurpose: 'Purchase',
    lastContact: at(-4, 12, 0),
    nextFollowUp: at(3, 9, 0),
    campaignName: '',
    status: 'snoozed',
  },
]
